(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46032],{

/***/ 11749:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/beta/SinglePage",
      function () {
        return __webpack_require__(79979);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SinglePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26492);



function SinglePage(props) {
    var onDocumentLoadSuccess = function onDocumentLoadSuccess(param) {
        var numPages = param.numPages;
        setNumPages(numPages);
        setPageNumber(1);
    };
    var changePage = function changePage(offset) {
        setPageNumber(function(prevPageNumber) {
            return prevPageNumber + offset;
        });
    };
    var previousPage = function previousPage() {
        changePage(-1);
    };
    var nextPage = function nextPage() {
        changePage(1);
    };
    var firstPage = function firstPage() {
        setPageNumber(1);
    };
    var lastPage = function lastPage() {
        setPageNumber(numPages);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), numPages = ref[0], setNumPages = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), pageNumber = ref1[0], setPageNumber = ref1[1]; //setting 1 to show fisrt page
    react_pdf__WEBPACK_IMPORTED_MODULE_2__/* .pdfjs.GlobalWorkerOptions.workerSrc */ .v0.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(react_pdf__WEBPACK_IMPORTED_MODULE_2__/* .pdfjs.version */ .v0.version, "/pdf.worker.js");
    var pdf = props.pdf;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full center space-y-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_2__/* .Document */ .BB, {
                file: pdf,
                options: {
                    workerSrc: "/pdf.worker.js"
                },
                onLoadSuccess: onDocumentLoadSuccess,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T3, {
                    pageNumber: pageNumber
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            "Page ",
                            pageNumber || (numPages ? 1 : "--"),
                            " of ",
                            numPages || "--"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "space-x-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "btn btn-outline-primary",
                                disabled: pageNumber <= 1,
                                onClick: firstPage,
                                children: " <<"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "btn btn-outline-primary",
                                disabled: pageNumber <= 1,
                                onClick: previousPage,
                                children: " <"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "btn btn-outline-primary",
                                disabled: pageNumber >= numPages,
                                onClick: nextPage,
                                children: "  >"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "btn btn-outline-primary",
                                disabled: pageNumber >= numPages,
                                onClick: lastPage,
                                children: "  >>"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 14601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32767:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 28251:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 57677:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 87324:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [94824,6172,49774,92888,40179], function() { return __webpack_exec__(11749); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);